import { render, staticRenderFns } from "./FormBoxRadioset.vue?vue&type=template&id=28947aae&scoped=true"
import script from "./FormBoxRadioset.vue?vue&type=script&lang=js"
export * from "./FormBoxRadioset.vue?vue&type=script&lang=js"
import style0 from "./FormBoxRadioset.vue?vue&type=style&index=0&id=28947aae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28947aae",
  null
  
)

export default component.exports